<template>
  <div class="map-container" >
    <div ref="map" class="map"></div>
  </div>
</template>

<script>

  import BackendProxy from '@/BackendProxy';

  export default {
    name: "LocationMap",
    props: ['lat', 'lng'],
    mounted() {

      // const pos = new google.maps.LatLng(Number(this.lat),  Number(this.lng));
      const pos = new google.maps.LatLng(Number(this.lat), Number(this.lng));

      console.log(pos, this.lat, this.lng);

      const options = {
        zoom: 15,
        center: pos,
        styles: BackendProxy.instance.mapStyle,
        mapTypeControl: false
      };
      const map = new google.maps.Map(this.$refs.map, options);
      const marker = new google.maps.Marker({
        position: pos,
        map: map
      });
    }
  }
</script>

<style scoped>

  .map-container {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 70%;
    margin-bottom: 2rem;
  }

  .map {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;


  }
</style>



// WEBPACK FOOTER //
// src/components/blocks/LocationMap.vue